import { useEffect } from "react";
import { Button } from "react-bootstrap";
import { FaRocket, 
  FaBrain, 
  FaUsers, 
  FaGraduationCap, 
  FaChalkboardTeacher  } from "react-icons/fa";
import { Helmet } from "react-helmet";
import CoursesNavbar from "../components/CoursesNavbar";
import IndustryShowcase2 from "../components/IndustryShowcase2";
import CertificateSection from "../components/CertificateSection";
import GetAdmissionForm from "../components/GetAdmissionForm";
import TrainingFooter from "../components/Tranining Footer";
import TopSplitSection from "../components/TopSplitSection";
import FAQSectionHomepage from "../components/FAQSectionHomepage";
import MeetInstructors from "../components/MeetInstructors";

export default function Training() {
  const featureCards = [
    { text: "Boost Your Career", icon: <FaRocket size={30} /> },
    { text: "Access The Talent", icon: <FaBrain size={30} /> },
    { text: "Professional Networking", icon: <FaUsers size={30} /> },
    { text: "Certified", icon: <FaGraduationCap size={30} /> },
    { text: "Learning & Earning", icon: <FaChalkboardTeacher size={30} /> },
  ];

  // Smooth scroll to GetAdmissionForm if hash is present
  useEffect(() => {
    if (window.location.hash === "#admission-form") {
      // Delay to allow the component to fully render
      setTimeout(() => {
        const formSection = document.getElementById("admission-form");
        if (formSection) {
          formSection.scrollIntoView({ behavior: "smooth" });
        }
      }, 500); // 0.5 seconds delay
    }
  }, []);

  return (
    <>
      {/* Meta Title */}
      <Helmet>
        <title>Best Training Institute of Career Development in Bangladesh</title>
        <meta
          name="description"
          content="JK Associates offers professional courses for career development in Bangladesh. Boost your career with our practical training programs."
        />
      </Helmet>

      <CoursesNavbar />

      {/* Hero Section */}
      <div
        style={{
          position: "relative",
          overflow: "hidden",
          padding: "80px 20px",
          textAlign: "center",
          color: "#fff",
        }}
      >
        {/* Background shapes */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom right, #1e3a8a, #2563eb, #3b82f6)",
            clipPath: "polygon(0px 0px, 100% 0px, 85% 100%, 0px 100%)",
            zIndex: 0,
            animation: "slideBg 20s ease-in-out infinite alternate",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(to bottom right, #2563eb, #3b82f6)",
            clipPath: "polygon(85% 0px, 100% 0px, 100% 85%, 85% 100%)",
            opacity: 0.8,
            zIndex: 0,
            animation: "slideBg2 30s ease-in-out infinite alternate",
          }}
        />

        <div style={{ position: "relative", zIndex: 1 }}>
          <h1 style={{ fontSize: "38px", fontWeight: "bold" }}>
            Grow your career <span style={{ color: "#ffd700" }}>with professional training</span>
          </h1>
          <p style={{ fontSize: "16px", marginTop: "10px" }}>
            Our knowledge and practical experience based professional courses will get you hired.
          </p>

          {/* Feature Cards */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              marginTop: "40px",
            }}
          >
            {featureCards.map((item, index) => (
              <div
                key={index}
                style={{
                  backgroundColor: "rgba(255,255,255,0.1)",
                  borderRadius: "12px",
                  width: "220px",
                  height: "220px",
                  color: "#fff",
                  fontWeight: "300",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  padding: "20px",
                  transition: "transform 0.3s",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              >
                <div style={{ marginBottom: "15px" }}>{item.icon}</div>
                <span style={{ fontSize: "15px" }}>{item.text}</span>
              </div>
            ))}
          </div>

          <Button
            style={{
              marginTop: "40px",
              backgroundColor: "#fff",
              color: "#0052D4",
              fontWeight: "bold",
              border: "none",
              padding: "10px 25px",
              fontSize: "16px",
              borderRadius: "6px",
            }}
            onClick={() =>
              window.open(
                "https://api.whatsapp.com/send/?phone=01601404971&text&type=phone_number&app_absent=0",
                "_blank"
              )
            }
          >
            Start your course today →
          </Button>
        </div>

        <style>
          {`
            @keyframes slideBg {
              0% { transform: translateX(0px) translateY(0px); }
              100% { transform: translateX(-20px) translateY(-10px); }
            }
            @keyframes slideBg2 {
              0% { transform: translateX(0px) translateY(0px); }
              100% { transform: translateX(15px) translateY(10px); }
            }
            @media (max-width: 768px) {
              h1 { font-size: 28px !important; }
              div[style*="width: 220px"] { width: 100% !important; height: auto !important; padding: 30px !important; }
              div[style*="display: flex"][style*="flex-wrap: wrap"] { gap: 15px !important; }
            }
          `}
        </style>
      </div>

      <IndustryShowcase2 />
      <TopSplitSection />
      <CertificateSection />
      <MeetInstructors />
      <FAQSectionHomepage />
      {/* Add an id to scroll */}
      <div id="admission-form">
        <GetAdmissionForm />
      </div>
      <TrainingFooter />
    </>
  );
}
